import React, { useState } from 'react'
import { Box, Button, Grid , Typography, Switch,FormControlLabel, Dialog, SxProps} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';
import { useNavigate } from 'react-router-dom';
import AllEstimate from './AllEstimate';
import CalculateIcon from '@mui/icons-material/Calculate';
import Avatar from '@mui/material/Avatar';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ChatJob from '../Cashjob/ChatJob';

const avatarStyle = {
  display: 'flex',
  width: '50px',
  height: '50px',
  bgcolor: '#c8e6c9',
};
// const sx: SxProps = {
//   "& .MuiDialog-container": {
//     alignItems: "flex-start"
//   }
// };
// const useStyles = makeStyles({
//   dialog: {
//     position: 'absolute',
//     right: 10,
//     // left: 100,
//     top: 50,
//     width:400
//   }
// });
function CustomColumnMenu(props) {
  return (
      <GridColumnMenu
          {...props}
          slots={{
              // Hide `columnMenuColumnsItem`
              columnMenuColumnsItem: null,
              columnMenuSortItem: null,
          }}
      />
  );
}
const columns = [
  
  { field: 'EstimateNo', headerName: 'Estimate No', editable: false, sortable: false, minWidth: 100 },
  { field: 'EnquiryNo', headerName: 'Enquiry No', editable: false, sortable: false, minWidth: 100 },
  { field: 'EstimateDate', headerName: 'Date', editable: false, sortable: false, minWidth: 100},
  { field: 'PreparedBy', headerName: 'Prepared By', editable: false, sortable: false, minWidth: 100 },
  { field: 'VehicleNo', headerName: 'VRM', editable: false, sortable: false,  minWidth: 100},
  { field: 'Owner', headerName: 'Customer', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'Mob_No', headerName: 'Mob No: ', editable: false, sortable: false,flex: 1 ,  minWidth: 100},
  { field: 'AppoimentDate', headerName: 'Appoiment ', editable: false, sortable: false,  minWidth: 100},
  { field: 'TotalParts', headerName: 'Total Parts', editable: false, sortable: false, minWidth: 100 },
  { field: 'TotalLabour', headerName: 'Total Labour', editable: false, sortable: false,minWidth: 100 },
  { field: 'NetTotal', headerName: 'Net Total', editable: false, sortable: false, minWidth: 100},
  { field: 'enstatus', headerName: 'Status', editable: false, sortable: false,minWidth: 100 },
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
    return (
    <ActionButtons title='Convert To Service Order' status={params.row.enstatus==='Estimate'?true:false} page='add_service_order'/>
    );
    }}
];

 

const rows = [

  { EstimateNo: 1251, EnquiryNo:1234, EstimateDate: '01-02-2023', PreparedBy: 'Lincoln', Owner: 'Oliver Jake Jack Connor',Mob_No:'731-487-0128',AppoimentDate:'05-05-2023', VehicleNo:'KZ66 ZYT', enstatus:'Estimate', TotalParts:5,TotalLabour:1,NetTotal: 358},
  { EstimateNo: 1252, EnquiryNo:1235,EstimateDate: '01-02-2023', PreparedBy: 'William', Owner: 'John Fitzgerald Kennedy',Mob_No:'850-585-7045',AppoimentDate:'05-05-2023', VehicleNo:'PZ65 PWO', enstatus:'Estimate', TotalParts:3,TotalLabour:2,NetTotal: 589},
  { EstimateNo: 1254, EnquiryNo:1239, EstimateDate: '01-02-2023', PreparedBy: 'Ambrose', Owner: 'Liam John Mason Robert',Mob_No:'334-741-0808',AppoimentDate:'05-05-2023', VehicleNo:'HZ13 WDD', enstatus:'Service', TotalParts:6,TotalLabour:4,NetTotal: 890},
  { EstimateNo: 1255, EnquiryNo:1241, EstimateDate: '01-02-2023', PreparedBy: 'Aloysius', Owner: 'Christopher Dominic Gabriel',Mob_No:'850-585-7045',AppoimentDate:'05-05-2023', VehicleNo:'PZ65 BYV', enstatus:'Estimate', TotalParts:2,TotalLabour:2,NetTotal: 520},
  ];
function Estimate() {
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate()
  const [isAllData, setIsAllData] = useState(false)
  const pageChange = (e) => { {setIsAllData(e.target.checked)}};
return (
  <Box mt={2}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
              ESTIMATE DETAILS
            </Typography>
          </Grid>
          <Grid item xs={2}>
              <Box display="flex" justifyContent="flex-end" sx={{mt:'5px'}}>
                <span>Pending</span>
                <FormControlLabel
                  sx={{ marginLeft: "20px" }}
                  control={<Switch size="small" color="success" checked={isAllData} onChange={pageChange}/>}                  
                />
                <span>All Data</span>
              </Box>
          </Grid>
          {/* <Grid item xs={2} display='flex' justifyContent='flex-end'>
            <Button sx={buttonStyle.root} onClick={() => navigate('/estimate_task/1')}><AddIcon />Add Estimate</Button>
            </Grid> */}
            </Grid>
            </Grid>
            <Grid item xs={12} mt={1}>
            {!isAllData && 
              <Box sx={dataGridStyle.root}>
              <DataGrid
              columnHeaderHeight={42}
              rowHeight={40}
              rows={rows.filter(item => item.enstatus === 'Estimate')}
              columns={columns}
              getRowId={(row) => row.EstimateNo}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              slots={{ columnMenu: CustomColumnMenu }}
              disableRowSelectionOnClick
            />
          </Box>
          }
          {isAllData && <AllEstimate columns={columns} rows={rows}/>}
        </Grid>
      <Grid item xs={12} display='flex' justifyContent='flex-end' mt={35}>
        <Box mt={2} >
          <Grid container spacing={1} >
            <Grid item xs={12} >
              <div>
                <Avatar sx={avatarStyle}>
                  <CalculateIcon sx={{color:'#66bb6a'}} onClick={handleClickOpen}/>
                </Avatar>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  sx={{ position: 'absolute',
                      // right: 10,
                      left: 1050,
                      top: 60,
                      width:450
                    }}
                  // classes={{
                  // paper: classes.dialog
                  //  }}
                   >
                  <DialogContent>
                    <ChatJob/>
                  </DialogContent>
                  <DialogActions>
                    <Button sx={buttonStyle.root} onClick={handleClickOpen}> {" "} Save{" "} </Button> &nbsp;
                    <Button sx={buttonStyle.root} onClick={handleClose}  > {" "} Cancel{" "} </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  </Box>
  )
}

export default Estimate